import { LOGIN_START_LOADING, LOGIN_END_LOADING, LOGIN_LOADED, LOGIN_TOKEN_LOADED, LOGIN_DATA_LOADED, CHANGE_PASSWORD_LOADED } from "../constants/LoginConstants";

import * as commonActions from "./CommonActions";
import { getApiData, postApiJsonData  } from "../utils/index";

export function getUserInfo(data) {
    var user_info = data.responseEntities[0].simpleUser;

    user_info.isCrmUser = data.responseEntities[0].isCrmUser;
    user_info.isExternalUser = data.responseEntities[0].isExternalUser;

    user_info.isAdmin = data.responseEntities[0].isAdmin;
    user_info.isManager = data.responseEntities[0].isManager;
    user_info.isGroupLeader = data.responseEntities[0].isGroupLeader;
    user_info.isTechnicalUser = data.responseEntities[0].isTechnicalUser;
    user_info.isPdReviewer = data.responseEntities[0].isPdReviewer;
    user_info.isDecisionMaker = data.responseEntities[0].isDecisionMaker;
    user_info.isReporter = data.responseEntities[0].isReporter;
    user_info.isInspector = data.responseEntities[0].isInspector;
    user_info.isInspectorCoordinator = data.responseEntities[0].isInspectorCoordinator;
    user_info.isInspectionSupervisor = data.responseEntities[0].isInspectionSupervisor;
    user_info.isSampler = data.responseEntities[0].isSampler;
    user_info.isLabReportView = data.responseEntities[0].isLabReportView;
    user_info.isLabReportEdit = data.responseEntities[0].isLabReportEdit;
    user_info.isQuality = data.responseEntities[0].isQuality;
    user_info.isCompliance = data.responseEntities[0].isCompliance;
    user_info.isQualityAudit = data.responseEntities[0].isQualityAudit;
    user_info.isExternalAudit = data.responseEntities[0].isExternalAudit;
    user_info.isViewAllCompleted = data.responseEntities[0].isViewAllCompleted;
    user_info.isViewAllClosed = data.responseEntities[0].isViewAllClosed;
    user_info.isViewAll = data.responseEntities[0].isViewAll;
    user_info.isDataProcessing = data.responseEntities[0].isDataProcessing;
    user_info.isDataQualityAnalyst = data.responseEntities[0].isDataQualityAnalyst;

    user_info.isIsoManager = data.responseEntities[0].isIsoManager;
    user_info.isIsoOperationManager = data.responseEntities[0].isIsoOperationManager;
    user_info.isIsoCertificationAdmin = data.responseEntities[0].isIsoCertificationAdmin;
    user_info.isIsoSacMdcIssuer = data.responseEntities[0].isIsoSacMdcIssuer;
    user_info.isIsoNonSacMdcIssuer = data.responseEntities[0].isIsoNonSacMdcIssuer;
    user_info.isIsoSchedulingResponsible = data.responseEntities[0].isIsoSchedulingResponsible;
    user_info.isIsoAuditDocumentReviewer = data.responseEntities[0].isIsoAuditDocumentReviewer;
    user_info.isIsoTechnicalReviewer = data.responseEntities[0].isIsoTechnicalReviewer;
    user_info.isIsoDecisionMaker = data.responseEntities[0].isIsoDecisionMaker;
    user_info.isIsoAuditor = data.responseEntities[0].isIsoAuditor;
    
    user_info.isIdiCoordinator = data.responseEntities[0].isIdiCoordinator;
    user_info.isIdiDesignTeam = data.responseEntities[0].isIdiDesignTeam;
    user_info.isIdiTeamLead = data.responseEntities[0].isIdiTeamLead;
    user_info.isIdiInspector = data.responseEntities[0].isIdiInspector;
    user_info.isIdiInspectorOnly = data.responseEntities[0].isIdiInspectorOnly;
    
    user_info.isIneManager = data.responseEntities[0].isIneManager;
    user_info.isIneSales = data.responseEntities[0].isIneSales;
    user_info.isIneAreaManager = data.responseEntities[0].isIneAreaManager;
    user_info.isIneTechnicalManager = data.responseEntities[0].isIneTechnicalManager;
    user_info.isIneInspector = data.responseEntities[0].isIneInspector;
    user_info.isIneFinance = data.responseEntities[0].isIneFinance;
    user_info.isIneStoreKeeper = data.responseEntities[0].isIneStoreKeeper;

    user_info.canAddRequest = data.responseEntities[0].canAddRequest;
    user_info.canAddIneRequest = data.responseEntities[0].canAddIneRequest;
    user_info.canAddClientDocumentRequest = data.responseEntities[0].canAddClientDocumentRequest;
    user_info.canViewClientDocumentRequest = data.responseEntities[0].canViewClientDocumentRequest;
    user_info.canAddIdiProject = data.responseEntities[0].canAddIdiProject;
    user_info.canViewIdiProject = data.responseEntities[0].canViewIdiProject;
    user_info.canViewIdiInspection = data.responseEntities[0].canViewIdiInspection;
    user_info.canAssignMe = data.responseEntities[0].canAssignMe;
    user_info.canAssignMePd = data.responseEntities[0].canAssignMePd;
    user_info.canAssignMeDecisionMaker = data.responseEntities[0].canAssignMeDecisionMaker;
    user_info.canAssignMeInspection = data.responseEntities[0].canAssignMeInspection;
    user_info.canAssignMeSampling = data.responseEntities[0].canAssignMeSampling;
    user_info.canAssignAny = data.responseEntities[0].canAssignAny;
    user_info.canAssignInspection = data.responseEntities[0].canAssignInspection;
    user_info.canViewReportData = data.responseEntities[0].canViewReportData;
    user_info.canViewLabReport = data.responseEntities[0].canViewLabReport;
    user_info.canEditLabReport = data.responseEntities[0].canEditLabReport;
    user_info.canManageCompany = data.responseEntities[0].canManageCompany;
    user_info.canManageUser = data.responseEntities[0].canManageUser;
    user_info.canManageAuditor = data.responseEntities[0].canManageAuditor;
    user_info.canManageTechnicalReviewer = data.responseEntities[0].canManageTechnicalReviewer;
    user_info.canManageInspector = data.responseEntities[0].canManageInspector;
    user_info.canManageIneInspector = data.responseEntities[0].canManageIneInspector;
    user_info.canManageGroup = data.responseEntities[0].canManageGroup;
    user_info.canAddCustomer = data.responseEntities[0].canAddCustomer;
    user_info.canManageCustomer = data.responseEntities[0].canManageCustomer;
    user_info.canManageImporter = data.responseEntities[0].canManageImporter;
    user_info.canManageExporter = data.responseEntities[0].canManageExporter;
    user_info.canManageManufacturer = data.responseEntities[0].canManageManufacturer;
    user_info.canManageProduct = data.responseEntities[0].canManageProduct;
    user_info.canManageTestingScope = data.responseEntities[0].canManageTestingScope;
    user_info.canManageCalendar = data.responseEntities[0].canManageCalendar;
    user_info.canManageIdiCustomer = data.responseEntities[0].canManageIdiCustomer;
    user_info.canManageIdiInspector = data.responseEntities[0].canManageIdiInspector;

    user_info.showDraft = data.responseEntities[0].showDraft;
    user_info.showNew = data.responseEntities[0].showNew;
    user_info.showInProgress = data.responseEntities[0].showInProgress;
    user_info.showSalesAction = data.responseEntities[0].showSalesAction;
    user_info.showPdReview = data.responseEntities[0].showPdReview;
    user_info.showTechnicalReview = data.responseEntities[0].showTechnicalReview;
    user_info.showTechnicalSupport = data.responseEntities[0].showTechnicalSupport;
    user_info.showPendingForSampling = data.responseEntities[0].showPendingForSampling;
    user_info.showSamplingInProcess = data.responseEntities[0].showSamplingInProcess;
    user_info.showScheduled = data.responseEntities[0].showScheduled;
    user_info.showWaitingCorrectiveAction = data.responseEntities[0].showWaitingCorrectiveAction;
    user_info.showDataReview = data.responseEntities[0].showDataReview;
    user_info.showPhase1Evaluation = data.responseEntities[0].showPhase1Evaluation;
    user_info.showPendingForInspection = data.responseEntities[0].showPendingForInspection;
    user_info.showInspectionInProcess = data.responseEntities[0].showInspectionInProcess;
    user_info.showNonConformity = data.responseEntities[0].showNonConformity;
    user_info.showPhase2Evaluation = data.responseEntities[0].showPhase2Evaluation;
    user_info.showFinalDecision = data.responseEntities[0].showFinalDecision;
    user_info.showReadyToIssue = data.responseEntities[0].showReadyToIssue;
    user_info.showCompleted = data.responseEntities[0].showCompleted;
    user_info.showClosed = data.responseEntities[0].showClosed;
    user_info.showCancelled = data.responseEntities[0].showCancelled;
    user_info.showStopped = data.responseEntities[0].showStopped;
    user_info.showAborted = data.responseEntities[0].showAborted;

    user_info.showIsoDraft = data.responseEntities[0].showIsoDraft;
    user_info.showIsoNew = data.responseEntities[0].showIsoNew;
    user_info.showIsoSalesAction = data.responseEntities[0].showIsoSalesAction;
    user_info.showIsoCalculateManDays = data.responseEntities[0].showIsoCalculateManDays;
    user_info.showIsoScheduling = data.responseEntities[0].showIsoScheduling;
    user_info.showIsoAuditInProgress = data.responseEntities[0].showIsoAuditInProgress;
    user_info.showIsoDocumentReview = data.responseEntities[0].showIsoDocumentReview;
    user_info.showIsoTechnicalReview = data.responseEntities[0].showIsoTechnicalReview;
    user_info.showIsoDecisionMaking = data.responseEntities[0].showIsoDecisionMaking;
    user_info.showIsoCompleted = data.responseEntities[0].showIsoCompleted;
    user_info.showIsoClosed = data.responseEntities[0].showIsoClosed;
    user_info.showIsoAborted = data.responseEntities[0].showIsoAborted;

    user_info.showIneDraft = data.responseEntities[0].showIneDraft;
    user_info.showIneNew = data.responseEntities[0].showIneNew;
    user_info.showInePendingApproval = data.responseEntities[0].showInePendingApproval;
    user_info.showIneRejected = data.responseEntities[0].showIneRejected;
    user_info.showIneSalesAction = data.responseEntities[0].showIneSalesAction;
    user_info.showIneApprovalOfContract = data.responseEntities[0].showIneApprovalOfContract;
    user_info.showIneIssueWorkOrderForm = data.responseEntities[0].showIneIssueWorkOrderForm;
    user_info.showInePerformInspection = data.responseEntities[0].showInePerformInspection;
    user_info.showIneAwaitingSignature = data.responseEntities[0].showIneAwaitingSignature;
    user_info.showIneCompleted = data.responseEntities[0].showIneCompleted;
    user_info.showIneClosed = data.responseEntities[0].showIneClosed;
    user_info.showIneAborted = data.responseEntities[0].showIneAborted;

    user_info.showIdiDraft = data.responseEntities[0].showIdiDraft;
    user_info.showIdiNew = data.responseEntities[0].showIdiNew;
    user_info.showIdiDesignReview = data.responseEntities[0].showIdiDesignReview;
    user_info.showIdiDesignReviewAccepted = data.responseEntities[0].showIdiDesignReviewAccepted;
    user_info.showIdiDesignReviewRejected = data.responseEntities[0].showIdiDesignReviewRejected;
    user_info.showIdiUploadedToBalady = data.responseEntities[0].showIdiUploadedToBalady;
    user_info.showIdiFoundation = data.responseEntities[0].showIdiFoundation;
    user_info.showIdiGroundBeam = data.responseEntities[0].showIdiGroundBeam;
    user_info.showIdiColumns = data.responseEntities[0].showIdiColumns;
    user_info.showIdiSlab = data.responseEntities[0].showIdiSlab;
    user_info.showIdiWaterproofing = data.responseEntities[0].showIdiWaterproofing;
    user_info.showIdiFinishes = data.responseEntities[0].showIdiFinishes;
    user_info.showIdiProjectCompletion = data.responseEntities[0].showIdiProjectCompletion;
    user_info.showIdiCompleted = data.responseEntities[0].showIdiCompleted;
    user_info.showIdiClosed = data.responseEntities[0].showIdiClosed;
    user_info.showIdiCancelled = data.responseEntities[0].showIdiCancelled;
    user_info.showIdiAborted = data.responseEntities[0].showIdiAborted;

    user_info.showIdiInspectionDraft = data.responseEntities[0].showIdiInspectionDraft;
    user_info.showIdiInspectionPendingForInspection = data.responseEntities[0].showIdiInspectionPendingForInspection;
    user_info.showIdiInspectionInspectionInProcess = data.responseEntities[0].showIdiInspectionInspectionInProcess;
    user_info.showIdiInspectionReadyForReview = data.responseEntities[0].showIdiInspectionReadyForReview;
    user_info.showIdiInspectionUploadToTawuniya = data.responseEntities[0].showIdiInspectionUploadToTawuniya;
    user_info.showIdiInspectionCompleted = data.responseEntities[0].showIdiInspectionCompleted;
    user_info.showIdiInspectionClosed = data.responseEntities[0].showIdiInspectionClosed;
    user_info.showIdiInspectionAborted = data.responseEntities[0].showIdiInspectionAborted;

    user_info.showMyTicketsOnly = data.responseEntities[0].showMyTicketsOnly;
    user_info.showMyIsoTicketsOnly = data.responseEntities[0].showMyIsoTicketsOnly;

    user_info.canViewReview = data.responseEntities[0].canViewReview;
    user_info.canViewShipmentCertificate = data.responseEntities[0].canViewShipmentCertificate;
    user_info.canViewProductCertificate = data.responseEntities[0].canViewProductCertificate;
    user_info.canViewFactoryAudit = data.responseEntities[0].canViewFactoryAudit;
    user_info.canViewCosmetic = data.responseEntities[0].canViewCosmetic;
    user_info.canViewProcessedFood = data.responseEntities[0].canViewProcessedFood;
    user_info.canViewFreshFood = data.responseEntities[0].canViewFreshFood;
    user_info.canViewChilledFood = data.responseEntities[0].canViewChilledFood;
    user_info.canViewInspection = data.responseEntities[0].canViewInspection;
    user_info.canViewSampling = data.responseEntities[0].canViewSampling;
    user_info.canViewNotify = data.responseEntities[0].canViewNotify;
    user_info.canViewCalendar = data.responseEntities[0].canViewCalendar;

    return user_info;
}

export function getUserData(data) {
    var user_data = {
        serviceList: data.responseEntities[0].serviceList
        , userServiceList: data.responseEntities[0].userServiceList
        , userRegionList: data.responseEntities[0].userRegionList
        , actionTypeList: data.responseEntities[0].actionTypeList
        , currencyList: data.responseEntities[0].currencyList
        , documentTypeList: data.responseEntities[0].documentTypeList
        , paymentStatusList: data.responseEntities[0].paymentStatusList
        , ticketStatusList: data.responseEntities[0].ticketStatusList
        , technicalRegulationList: data.responseEntities[0].technicalRegulationList
        , caiList: data.responseEntities[0].caiList
        , caiCosmeticList: data.responseEntities[0].caiCosmeticList
        , caiFoodList: data.responseEntities[0].caiFoodList
    }

    return user_data;
}

export function getUserToken(data) {
    return data.responseEntities[0].token;
}

export async function sendOTP(email, password) {
    var returnData = {
        success: false,
        errorCode: "",
        error: null
    };

    try {

        var data = await postApiJsonData("UserProfile/SendOTP", { email, password }, null, false);
        
        if(data.success) {
            returnData.success = true;
            returnData.errorCode = data.errorCode;
        }
        else {
            returnData.error = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.error = error;
    }

    return returnData;
}

export async function getOTPList() {
    var returnData = {
        success: false,
        errorMessage: "",
        list: []
    };

    try {

        var data = await getApiData("UserProfile/GetOTPList", null, false);
        
        if(data.success) {
            returnData.success = true;
            returnData.list = data.responseEntities;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export function loadLogin(email, password, otp) {
    return async (dispatch) => {
        
        await dispatch({ type: LOGIN_START_LOADING });

        try {
            
            const data = await postApiJsonData("UserProfile/Login", { email, password, otp }, null, false);
            
            if(data.success) {
                var user_info = getUserInfo(data);
                var user_data = getUserData(data);
                var user_token = getUserToken(data);

                localStorage.setItem("ticketing_user_info", JSON.stringify(user_info));
                localStorage.setItem("ticketing_user_data", JSON.stringify(user_data));
                localStorage.setItem("ticketing_user_token", user_token);
                localStorage.setItem("ticketing_user_extra", "0");

                await dispatch({
                    type: LOGIN_LOADED,
                    payload: user_info
                });

                await dispatch({
                    type: LOGIN_TOKEN_LOADED,
                    payload: data.responseEntities[0].token
                });

                await dispatch({
                    type: LOGIN_DATA_LOADED,
                    payload: user_data
                });
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
                                    
			await dispatch({ type: LOGIN_END_LOADING });
        }
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: LOGIN_END_LOADING });
        }
    };
}

export function loadLogout() {
    return async (dispatch) => {
        
        await dispatch({
            type: LOGIN_LOADED,
            payload: null
        });

        await dispatch({
            type: LOGIN_TOKEN_LOADED,
            payload: ""
        });

        await dispatch({
            type: LOGIN_DATA_LOADED,
            payload: {
                serviceList: []
                , actionTypeList: []
                , currencyList: []
                , documentTypeList: []
                , paymentStatusList: []
                , ticketStatusList: []
                , technicalRegulationList: []
                , caiList: []
                , caiCosmeticList: []
            }
        });

        localStorage.removeItem("ticketing_user_info");
        localStorage.removeItem("ticketing_user_data");
        localStorage.removeItem("ticketing_user_token");
        localStorage.removeItem("ticketing_user_extra");
    };
}

export function forgotPassword(email) {
    return async (dispatch) => {
        
        await dispatch({ type: LOGIN_START_LOADING });

        try {
            
            const data = await postApiJsonData("UserProfile/ForgotPassword", { email }, null, false);
            
            if(data.success) {
                dispatch(commonActions.setSuccessMessage("Password reset email is sent to your email, please follow the instruction in mail to reset password."));
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
                                    
			await dispatch({ type: LOGIN_END_LOADING });
        }
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: LOGIN_END_LOADING });
        }
    };
}

export function loadChangePassword(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: LOGIN_START_LOADING });

        try {
            
            var data = await getApiData("UserProfile/GetChangePasswordFBO", { id }, false);
            
            if(data.success) {
                await dispatch({
                    type: CHANGE_PASSWORD_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                navigate('/');
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: LOGIN_END_LOADING });
        } 
        catch (error) {
            navigate('/');
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: LOGIN_END_LOADING });
        }
    };
}

export function saveChangePassword(fbo, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: LOGIN_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("UserProfile/SaveChangePasswordFBO", null, fbo, false);
            
            if(data.success) {
                navigate('/');
                dispatch(commonActions.setSuccessMessage("Password Changed Successfully!"));
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: LOGIN_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: LOGIN_END_LOADING });
        }
    };
}

export async function changeCompanyAndModule(companyId, moduleName) {
    var returnData = {
        success: false,
        error: null
    };

    try {

        var data = await postApiJsonData("UserProfile/ChangeCompanyAndModule", { companyId, moduleName }, null, true);
        
        if(data.success) {
            returnData.success = true;

            var user_info = getUserInfo(data);
            var user_data = getUserData(data);
            var user_token = getUserToken(data);

            localStorage.setItem("ticketing_user_info", JSON.stringify(user_info));
            localStorage.setItem("ticketing_user_data", JSON.stringify(user_data));
            localStorage.setItem("ticketing_user_token", user_token);
        }
        else {
            returnData.error = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.error = error;
    }

    return returnData;
}